module.exports = __webpack_public_path__ + "static/clelia-5b2a7bca64a7ab4d36b3c3c3739c4d05.jpg";